<template lang='pug' src='./footer.pug'></template>

<script>
import Icon from 'components/icon/icon'
import ScrollButton from 'components/block/block-scroll-button/block-scroll-button'
import FunctionButton2 from 'components/block/block-function-button-2/block-function-button-2'
import MainForm from 'components/form/form'
import HomeForm from 'components/custom/custom-home-form/custom-home-form'
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, { siteKey: '6LfYi5QUAAAAAJBgI3pmjkMntb9MMtifvC-pK5KD' })

export default {
  computed: {
    information () {
      return [
        {
          path: 'tel:+14076271187',
          text: 'Call Us! 407.627.1187'
        },
        {
          path: 'sms:+8336771187',
          text: 'Text Us! 833.677.1187'
        },
        {
          path: 'https://www.google.com/maps/place/Anderson+and+Moopen+Orthodontics+-+Lake+Nona/@28.4340691,-81.2584571,17z/data=!3m1!4b1!4m5!3m4!1s0x88e763d24985727d:0xd1939f685ee50a26!8m2!3d28.4340644!4d-81.2562684',
          text: '9161 Narcoossee Rd<br>Suite 105-B,<br>Orlando, FL 32827'
        }
      ]
    },
    button () {
      return {
        label: 'Schedule an appointment'
      }
    },
    icons () {
      return [
        {
          image: 'https://lakenonaorthodontics.com/wp-content/uploads/AdvantageBadges_CMYK_fullColor_Diamond-top-tag.png'
        },
        {
          image: 'https://lakenonaorthodontics.com/wp-content/uploads/AAO-1.png'
        },
        {
          image: 'https://lakenonaorthodontics.com/wp-content/uploads/top-ortho-orlando.png'
        },
        {
          image: 'https://lakenonaorthodontics.com/wp-content/uploads/abo_seal_white-1.png'
        }
      ]
    },
    social () {
      return [
        {
          path: 'https://www.instagram.com/sakowitzsmiles',
          icon: 'ig-icon'
        },
        {
          path: 'https://www.facebook.com/sakowitzsmiles',
          icon: 'facebook-icon'
        }
      ]
    }
  },
  methods: {
    openModal (e) {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', e)
    },
    recaptcha () {
      this.$recaptcha('login').then((token) => {
        console.log(token) // Will print the token
      })
    },
    dropup () {
      this.isOpen = !this.isOpen
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  components: {
    Icon,
    ScrollButton,
    MainForm,
    HomeForm,
    FunctionButton2
  },
  template: '<button @click="recaptcha">Execute recaptcha</button>'
}
</script>



// WEBPACK FOOTER //
// footer.vue?299fc22c